/* eslint-disable react/forbid-prop-types */

import PropTypes from 'prop-types';
import React from 'react';
import Layout from 'app/blocks/Layout/Layout';
import PageContainer from './PageContainer';

class PageLayout extends React.PureComponent {
    static propTypes = {
        children: PropTypes.node,
        errorMsg: PropTypes.string,
        isLoadingContent: PropTypes.bool,
        title: PropTypes.string,
    };

    static defaultProps = {
        children: null,
        errorMsg: null,
        isLoadingContent: false,
        title: null,
    };

    render() {
        const { children, errorMsg, isLoadingContent, seleniumid, title } = this.props;

        return (
            <PageContainer seleniumid={seleniumid} title={title}>
                <Layout className="lg-2x" errorMsg={errorMsg} isLoading={isLoadingContent}>
                    {children}
                </Layout>
            </PageContainer>
        );
    }
}

export default PageLayout;
